import axios from "axios";
import { API_ORIGIN } from "./base";

const apiClient = axios.create({
  // REACT_APP_API_URL (dev uses same-origin proxy via empty API_ORIGIN)
  baseURL: API_ORIGIN ? `${API_ORIGIN}/api/website` : "/api/website",
});

apiClient.defaults.headers.common["Content-Type"] = "application/json";

export default apiClient;
